import axios from "axios";
import _ from "lodash";
import { WP_ENDPOINT, WP_LIBRARY_BOOKS} from ".././config";

export default async function fetchBook(bookId) {
	let book = await axios.get(WP_ENDPOINT + WP_LIBRARY_BOOKS + '/' + bookId , {
		params: {fields:'acf'}
	});
	book = book.data.acf;
	book.chapters.forEach((chapter, index)=>chapter.id = index);
	return book;
}


// WEBPACK FOOTER //
// ./src/store/services/LibraryBook/index.js